import { Action, ThunkAction } from '@reduxjs/toolkit';

import { userService } from '@paragon/data-connections';

import { getLoggedInUserOrganization } from '../selectors/users';
import {
  organizationMembersFailed,
  organizationMembersLoaded,
  organizationMembersLoading,
  OrganizationMembersSliceState,
} from '../store/organizationMembersSlice';

export const loadOrganizationMembers =
  (): ThunkAction<Promise<void>, OrganizationMembersSliceState, void, Action> => async (dispatch, getState) => {
    const organization = getLoggedInUserOrganization(getState());
    if (!organization) {
      dispatch(organizationMembersFailed());
      return;
    }

    dispatch(organizationMembersLoading());

    try {
      dispatch(organizationMembersLoaded(await userService.users.fetchAllInOrganization(organization)));
    } catch (err) {
      console.error(err);
      dispatch(organizationMembersFailed());
    }
  };
